import Card from 'react-bootstrap/Card'
import styled from '@emotion/styled/macro'

const StyledCard = styled(Card)`
  border-radius: 3px;
  -webkit-box-shadow: 2px 2px 2px 0px var(--gray-2);
  box-shadow: 2px 2px 2px 0px var(--gray-2);
  display: inline-block;
  padding: 0;
  text-align: left;
  width: 100%;

  > .card-body {
    padding: 1rem;
  }
`

const StyledCardFooter = styled(Card.Footer)`
  border-top: 1px solid var(--gray-2);
  padding: 1rem;
  text-align: center;

  &.card-footer {
    background-color: inherit;
  }
`

const CourseCardHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  > h4 {
    width: 50%;
    font-weight: 500;
  }
`

const CourseCardPrice = styled('div')`
  text-align: right;
  width: 30%;

  > p {
    font-size: 0.8rem;
    margin: 0;
    padding: 0;
  }

  > span {
    color: var(--celeste);
    font-size: 0.875rem;
    font-weight: 500;

    .long {
      display: inline-block;
      font-size: 0.9rem;
      line-height: 0.9rem;
    }
  }
`

const CourseCardContent = styled('div')`
  > ul {
    font-size: 0.8rem;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      line-height: 1.4rem;

      ::before {
        color: var(--celeste);
        content: '•';
        display: inline-block;
        font-size: 1.25rem;
        font-weight: bold;
        vertical-align: middle;
        width: 0.8rem;
      }
    }
  }
`

export {
  CourseCardContent,
  CourseCardHeader,
  CourseCardPrice,
  StyledCard,
  StyledCardFooter
}
